module.exports = __webpack_public_path__ + "static/fonts/regular.b6d03e9.otf";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Fonts/DinCondense/regular.otf
// module id = 524
// module chunks = 0